export default "__VITE_ASSET__7c6f4ecc__"